import React from 'react'
import {BorderOutlined} from '@ant-design/icons'
import * as Icons from '@web/assets/icons'
export default function Icon({name, ...props}) {
  if (!name) return <BorderOutlined />
  const TheIcon = Icons[name]
  return TheIcon ? <TheIcon {...props} /> : <BorderOutlined />
}